"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapRequestStateToJSON = exports.MapRequestStateFromJSONTyped = exports.MapRequestStateFromJSON = exports.MapRequestState = void 0;
/**
 * The state of the mapping request.
 * @export
 */
exports.MapRequestState = {
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Requested: 'REQUESTED'
};
function MapRequestStateFromJSON(json) {
    return MapRequestStateFromJSONTyped(json, false);
}
exports.MapRequestStateFromJSON = MapRequestStateFromJSON;
function MapRequestStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MapRequestStateFromJSONTyped = MapRequestStateFromJSONTyped;
function MapRequestStateToJSON(value) {
    return value;
}
exports.MapRequestStateToJSON = MapRequestStateToJSON;
